<!-- <div class="container"> -->
  <!-- <div class="content-header">
    <logo [src]="'assets/img/foodbud.png'" [width]="147" [height]="33"></logo>
  </div> -->

  <!-- <div class="row h-100 ">
    <div class="col-md-12 my-auto"> -->

        <!-- <div class="content-body"> -->
          <router-outlet></router-outlet>
        <!-- </div> -->
    
    <!-- </div>
  </div> -->
 
<!-- </div> -->
